import { AbstractControl, FormGroup } from '@angular/forms';

export function applyValidationErrorsToForm(
  form: FormGroup,
  errors: Record<string, string[]>
): void {
  Object.keys(errors).forEach((field) => {
    const control = form.get(field);

    if (!control) return;

    const serverMessage = errors[field]?.[0] || 'Campo inválido.';

    control.setErrors({
      ...(control.errors || {}),
      server: serverMessage,
    });

    control.markAsTouched();
    control.markAsDirty();
  });
}

export function clearServerErrorsFromForm(form: FormGroup): void {
  Object.keys(form.controls).forEach((key) => {
    const control = form.get(key);

    if (!control) return;

    clearServerError(control);
  });
}

function clearServerError(control: AbstractControl): void {
  const errors = control.errors;

  if (!errors || !errors['server']) return;

  const { server, ...rest } = errors;

  control.setErrors(Object.keys(rest).length ? rest : null);
}
